import { useCallback } from 'react';

import { DateTime } from 'luxon';
import { Box, DatePickerInput, Grid, Select, SimpleGrid, TextInput, TimeInput } from 'ui';
import { UseFormReturnType } from 'ui/Form';

import { AddEditTicketFormType } from '../AddTicketForm.type';

type SeasonTicketSalesEndInputsProps = {
  form: UseFormReturnType<AddEditTicketFormType>;
};

const SeasonTicketSalesEndInputs = ({ form }: SeasonTicketSalesEndInputsProps) => {
  const ticketWindowData = form.values.ticket_window_data;
  const end = ticketWindowData?.end;

  const formattedEndTime = form.values.ticket_window_data?.end?.date
    ? DateTime.fromJSDate(form.values.ticket_window_data?.end?.date).toFormat('HH:mm:ss')
    : undefined;

  const handleTimeChange = useCallback(
    (value: string) => {
      const date = form.values.ticket_window_data?.end?.date
        ? DateTime.fromJSDate(form.values.ticket_window_data?.end?.date)
        : DateTime.now();

      const finalDateTime = date.set({
        hour: parseInt(value.split(':')[0]),
        minute: parseInt(value.split(':')[1]),
        second: 0,
        millisecond: 0,
      });
      form.setFieldValue('ticket_window_data.end.date', finalDateTime.toJSDate());
    },
    [form]
  );

  return (
    <SimpleGrid cols={2}>
      <Select
        label={'Ticket Sales End'}
        required
        data={[
          { label: '1 Hour After Last Event Date Starts', value: 'after_event' },
          { label: 'On a Specific Date', value: 'custom_date' },
        ]}
        allowDeselect={false}
        {...form.getInputProps('ticket_window_data.end.type')}
        onChange={(val) => {
          form.getInputProps('ticket_window_data.end.type').onChange(val);
        }}
      />
      <Box />
      {end?.type === 'custom_date' && (
        <>
          <DatePickerInput
            label="End Date"
            placeholder="Select end date"
            required
            {...form.getInputProps('ticket_window_data.end.date')}
          />
          <Grid>
            <Grid.Col span={6}>
              <TimeInput
                label="End Time"
                required
                defaultValue={formattedEndTime}
                onChange={(e) => handleTimeChange(e.target.value)}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <TextInput
                label="Timezone"
                value={Intl.DateTimeFormat().resolvedOptions().timeZone}
                readOnly
              />
            </Grid.Col>
          </Grid>
        </>
      )}
      {end?.type === 'after_event' && <Box />}
    </SimpleGrid>
  );
};

export default SeasonTicketSalesEndInputs;
